export const getNormalizedLeadSource = (leadInfo = {}) => {
    const source = (leadInfo?.UTM_Source || leadInfo?.UTMSource || "").toString().toLowerCase();

    if (["ig", "fb", "instagram", "facebook"].includes(source)) {
        return "Meta";
    }

    if (["google", "ads", "googleads", "google ads"].includes(source)) {
        return "Ads";
    }

    return leadInfo?.Kaynak || "";
};

export const normalizeLeadInfo = (lead) => {
    if (!lead || !lead.LeadInfo) {
        return lead;
    }

    return {
        ...lead,
        LeadInfo: {
            ...lead.LeadInfo,
            Kaynak: getNormalizedLeadSource(lead.LeadInfo)
        }
    };
};
